import React, { useEffect, useState, useSyncExternalStore } from 'react';
import {
  activateWaitingUpdate,
  getSnapshot,
  subscribe,
} from '../serviceWorkerRegistration';
import { useUploadQueue } from '../hooks/useUploadQueue';

function ServiceWorkerUpdateNotice() {
  const update = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  const { queue, isProcessing } = useUploadQueue();
  const [deferredWorker, setDeferredWorker] = useState(null);

  useEffect(() => {
    if (deferredWorker && deferredWorker !== update.waiting) {
      setDeferredWorker(null);
    }
  }, [deferredWorker, update.waiting]);

  useEffect(() => {
    if (!update.waiting || update.policy !== 'urgent') {
      return undefined;
    }

    activateWaitingUpdate();
    return undefined;
  }, [update.policy, update.waiting]);

  if (!update.waiting || (update.policy !== 'urgent' && deferredWorker === update.waiting)) {
    return null;
  }

  const hasActiveUpload =
    isProcessing || queue.some((item) => item.status === 'uploading');
  const isUrgent = update.policy === 'urgent';

  return (
    <div
      className="fixed inset-x-3 top-3 z-50 mx-auto max-w-md rounded-lg border border-[var(--color-primary)] bg-[var(--color-accent)] p-4 text-secondary shadow-lg"
      role={isUrgent ? 'alertdialog' : 'dialog'}
      aria-modal="false"
      aria-labelledby="service-worker-update-title"
      aria-describedby="service-worker-update-description"
    >
      <h2 id="service-worker-update-title" className="text-base font-semibold">
        {isUrgent ? 'Critical update in progress' : 'Update available'}
      </h2>
      <p id="service-worker-update-description" className="mt-2 text-sm">
        {isUrgent
          ? hasActiveUpload
            ? 'The app will reload in 3 seconds. Active uploads may be interrupted.'
            : 'The app will reload in 3 seconds. Uploads may be interrupted.'
          : 'A new version is ready. Close all Wedlinx tabs and windows, then reopen the app to update safely.'}
      </p>
      <div className="mt-4 flex justify-end gap-2">
        {!isUrgent && (
          <button
            type="button"
            className="min-h-11 rounded bg-[var(--color-primary)] px-3 text-sm font-semibold text-white"
            onClick={() => setDeferredWorker(update.waiting)}
          >
            Dismiss
          </button>
        )}
      </div>
    </div>
  );
}

export default ServiceWorkerUpdateNotice;
